
import MuiCardContent from '@mui/material/CardContent';

interface IProps {
  miniCard?: boolean;
  noPadding?: boolean;
}

export const EDCardContent: React.FC<
  React.PropsWithChildren<IProps>
> = props => (
  <MuiCardContent
    sx={{
      paddingTop: 0,
      paddingLeft: props.noPadding ? 0 : 1,
      paddingBottom: props.noPadding ? 0 : props.miniCard ? 0.5 : 1,
      paddingRight: 0,
      '&:last-child': {
        paddingBottom: props.noPadding ? 0 : props.miniCard ? 0.5 : 1,
      },
    }}
  >
    {props.children}
  </MuiCardContent>
);
